/**
 * Created by dimah on 18/06/17.
 */

/**
 * An array of data with an associated page object used for paging
 */
export class DTPagedData<T> {
    data = new Array<T>();
    extendedData = new Array<T>();
    page = new DTPage();
    filter = new Array<T>();

    constructor(attributes?: object) {
        attributes = attributes || {};

        this.data = attributes['data'] ;
        this.extendedData = attributes['extendedData'] ;
        this.page = attributes['page'];
        this.filter = attributes['filter'];
    }
}

/**
 * An object used to get page information from the server
 */
export class DTPage {
    //The number of elements in the page
    size: number;
    //The total number of elements
    totalElements: number;
    //The total number of pages
    totalPages: number;
    //The current page number
    pageNumber: number;

    constructor(attributes?: object) {
        attributes = attributes || {};

        this.size = Number(attributes['size']) || 15;
        this.totalElements = Number(attributes['totalElements']) || 0;
        this.totalPages = Number(attributes['totalPages']) || 0;
        this.pageNumber = Number(attributes['pageNumber']) || 0;
    }

    /**
     * Package companyData into a DTPagedData object based on the selected Page
     * @param page The page data used to get the selected data from companyData
     * @param data
     * @returns DTPagedData<object[]> An array of the selected data and page
     */
    static createFromArray(page: DTPage, data: any[] , filter: any[]): DTPagedData<object> {
        let pagedData = new DTPagedData<object>();
        page.totalElements = data.length;
        page.totalPages = page.totalElements / page.size;
        // let start = page.pageNumber * page.size;
        // let end = Math.min((start + page.size), page.totalElements);
        // for (let i = start; i < end; i++){
        //     pagedData.data = data;
        // }
        pagedData.data = data;
        pagedData.page = page;
        pagedData.filter = filter;
        return pagedData;
    }
}
